<template>
  <div class="user-wrapper">
    <!--<a href="https://pro.loacg.com/docs/getting-started" target="_blank">
      <span class="action">
        <a-icon type="question-circle-o"></a-icon>
      </span>
    </a>
    <notice-icon class="action"/>-->
    <!--    <a-dropdown>-->
    <div class="headerSpan">
      <div style="height: 100%;margin-right: 12px;">
        <p class="userSpan">
          {{ userInfo.deptFullName }}
        </p>
        <p class="userSpan">
          {{ userInfo.name }}
          <span v-if="userInfo.jobTitleName">
            ({{ userInfo.jobTitleName }})
          </span>
        </p>
      </div>
      <a-avatar class="avatar headerImg" size="small" :src="img"/>
    </div>
    <!--      <a-menu slot="overlay" class="user-dropdown-menu-wrapper">-->
    <!--        <a-menu-item key="0" @click="handleEditPersonalInfo">-->
    <!--          <a-icon type="user"/>-->
    <!--          <span>个人中心</span>-->
    <!--        </a-menu-item>-->
    <!--        <a-menu-item key="1" @click="handleEditPassword">-->
    <!--          <a-icon type="user"/>-->
    <!--          <span>修改密码</span>-->
    <!--        </a-menu-item>-->
    <!--        <a-menu-divider/>-->
    <!--        <a-menu-item key="4">-->
    <!--          <a href="javascript:;" @click="handleLogout">-->
    <!--            <a-icon type="logout"/>-->
    <!--            <span>退出登录</span>-->
    <!--          </a>-->
    <!--        </a-menu-item>-->
    <!--      </a-menu>-->
    <!--    </a-dropdown>-->

    <!-- 个人信息编辑模态框 -->
    <personal-modal ref="personalModal"></personal-modal>
    <password-modal ref="passwordModal"></password-modal>
  </div>
</template>

<script>
import NoticeIcon from '@/components/NoticeIcon'
import { mapActions, mapGetters } from 'vuex'
import PersonalModal from '@/views/role/baseInfo/modules/PersonalModal'
import passwordModal from '@/views/role/baseInfo/modules/passwordModal'
const img = require('@/assets/touxiang.png')
export default {
  name: 'UserMenu',
  components: {
    NoticeIcon,
    PersonalModal,
    passwordModal
  },
  data () {
    return {
      img: img
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'avatar'])
  },
  mounted () {
    console.log('userInfo', this.userInfo)
  },
  methods: {
    ...mapActions(['Logout']),
    handleLogout () {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk () {
          return that.Logout({}).then(() => {
            window.location.reload()
          }).catch(err => {
            that.$message.error({
              title: '错误',
              description: err.message
            })
          })
        },
        onCancel () {
        }
      })
    },
    handleEditPersonalInfo () {
      console.log('展示个人中心')
      this.$refs.personalModal.showModal(true)
    },
    handleEditPassword () {
      this.$refs.passwordModal.showModal(true)
    }
  }
}
</script>

<style lang="less" scoped>
.headerSpan {
  display: flex !important;
  align-items: center;
  justify-content: flex-end;
  padding: 0 12px;
  display: inline-block;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  height: 100%;
  color: rgba(0, 0, 0, 0.65);
  .headerImg {
    width: 30px;
    height: 30px;
    margin: 0!important;
  }
  .userSpan {
    height: 50%;
    line-height: 50%;
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
